<template lang="pug">
  .announce-inside(v-if="content")
    .page__wr
      Bread(v-if="content.bread", :bread="content.bread")
      .announce-inside__wr
        .announce-inside__left
          .announce-inside__left-box
            .announce-inside__left-img-wr
              img.announce-inside__left-img(v-if="content.img", :src="content.img")
            .announce-inside__left-box-content
              .announce-inside__left-box-item(v-if="content.date") {{content.date}}
              .announce-inside__left-box-item(v-if="content.time")
                SvgIcon.announce-inside__left-box-item-ico(name="clock", width="16", height="16")
                | #[span Время:] {{content.time}}
              .announce-inside__left-box-item(v-if="content.address")
                SvgIcon.announce-inside__left-box-item-ico(name="marker", width="16", height="16")
                | #[span Место проведения:]
              .announce-inside__left-box-item(v-if="content.address") {{content.address}}
            router-link.announce-inside__left-btn(to="/anonsy") Вернуться к списку анонсов
        .announce-inside__right
          .announce-inside__right-title(v-if="h1", v-html="h1")
          .announce-inside__right-text(v-if="content.text", v-html="content.text")
      .announce-inside__subtitle Фотографии с мероприятия
      .announce-inside__items(v-if="content.items")
        a.announce-inside__item(v-for="item in content.items", :key="item.id", :href="item.link", data-fancybox="gallery")
          .announce-inside__item-img-wr
            img.announce-inside__item-img(v-if="item.img", :src="item.img")
            .announce-inside__item-img-overlay
              SvgIcon.announce-inside__item-img-overlay-ico(name="search", width="34", height="34")
      button.announce-inside__btn(v-if="more", @click="loadMore") Загрузить еще
        SvgIcon.announce-inside__btn-ico(name="loader", width="24", height="24")
</template>

<script>
  import EventBus from '@/eventBus';

  import '@/components/announceInside/announceInside.styl';

  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
  import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
  import Bread from '@/components/common/bread/bread.vue';

  export default {
    name: 'AnnounceInside',

    mixins: [AjaxHelpersVue],

    data() {
      return {
        content: null,
        more: false
      }
    },

    components: {
      SvgIcon,
      Bread
    },

    created() {
      // Загрузка данных для страницы
      EventBus.$on('loadAnnounceInsidePage', params => {
        this.request(params.url);
      });
    },

    methods: {
      request(url) {
        this.req('AnnouncePage:getAnnounceInsidePage', {url}, res => {
          if(this.checkProperty(res.content)) {
            this.content = res.content;
            this.more = res.content.more;

            this.$nextTick(() => {
              this.initFancy();
            });
          }
        }, 'announce-inside');
      },

      initFancy() {
        $('.announce-inside__item').fancybox({
          touch: false,
          buttons: ['close'],
          animationEffect: 'zoom-in-out',
          infobar: false,
          btnTpl: {
            close:
            '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
            '<svg width="22" height="22" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M0.439883 1.76044C0.0753774 1.39593 0.0753774 0.804948 0.439883 0.440442C0.804389 0.0759363 1.39537 0.0759363 1.75988 0.440442L21.5598 20.2403C21.9243 20.6048 21.9243 21.1958 21.5598 21.5603C21.1953 21.9248 20.6043 21.9248 20.2398 21.5603L0.439883 1.76044Z" fill="currentColor"/>' +
            '<path d="M20.2398 0.440127C20.6043 0.0756216 21.1953 0.0756216 21.5598 0.440127C21.9243 0.804633 21.9243 1.39561 21.5598 1.76012L1.7599 21.56C1.39539 21.9245 0.804412 21.9245 0.439906 21.56C0.0754006 21.1955 0.0754006 20.6045 0.439906 20.24L20.2398 0.440127Z" fill="currentColor"/>' +
            '</svg>' +
            '</button>',
            arrowLeft:
            '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
            '<svg width="10" height="18" viewBox="0 0 10 18" xmlns="http://www.w3.org/2000/svg">' +
            '<path fill-rule="evenodd" clip-rule="evenodd" d="M7.73573 17.0018L1.15867 9.8001C0.755072 9.35817 0.755072 8.64166 1.15867 8.19973L7.73573 0.998029C8.13933 0.556097 8.7937 0.556097 9.1973 0.998029C9.6009 1.43996 9.6009 2.15647 9.1973 2.59841L3.35103 8.99992L9.1973 15.4014C9.6009 15.8434 9.6009 16.5599 9.1973 17.0018C8.7937 17.4437 8.13933 17.4437 7.73573 17.0018Z" fill="currentColor"/>' +
            '</svg>' +
            '</button>',
            arrowRight:
            '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
            '<svg width="10" height="18" viewBox="0 0 10 18" xmlns="http://www.w3.org/2000/svg">' +
            '<path fill-rule="evenodd" clip-rule="evenodd" d="M2.26427 0.998197L8.84133 8.1999C9.24493 8.64183 9.24493 9.35834 8.84133 9.80027L2.26427 17.002C1.86067 17.4439 1.2063 17.4439 0.8027 17.002C0.399098 16.56 0.399099 15.8435 0.8027 15.4016L6.64897 9.00008L0.802701 2.59857C0.3991 2.15664 0.3991 1.44013 0.802701 0.998197C1.2063 0.556265 1.86067 0.556265 2.26427 0.998197Z" fill="currentColor"/>' +
            '</svg>' +
            '</button>'
          },
          beforeShow: function() {
            $('.page').addClass('popup popup--effect');
          },
          beforeClose: function() {
            $('.page').removeClass('popup popup--effect');
          }
        });
      },

      loadMore() {
        $('.announce-inside__btn').addClass('announce-inside__btn--loading');

        let params = {
          id: this.content.id,
          count: this.content.items.length
        };

        this.req('AnnouncePage:getAnnounceInsideItems', {...params}, res => {
          if(this.checkProperty(res.content)) {
            this.content.items = this.content.items.concat(res.content.items);
            this.more = res.content.more;

            this.$nextTick(() => {
              this.initFancy();
              $('.announce-inside__btn').removeClass('announce-inside__btn--loading');
              $('.page__items').css('height', $('.page__item--active').outerHeight() + 'px');
            });
          }
        }, '', 'localPageRequest');
      },
    }

  }
</script>
